// extracted by mini-css-extract-plugin
module.exports = {"link_search_container":"shiftsStyles-link_search_container__F8__A","search_wrap":"shiftsStyles-search_wrap__2Cob9"};